<template>
  <div class="staff-basic">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="/filebackup/home"
      :fetchPage="true"
    >
      <el-table-column slot="number" label="文件数">
        <template v-slot="{row}">
          <el-button type="text" @click="goToDetail(row)">{{row.number}}</el-button>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'

export default {
  name: 'file',
  mixins: [ mixin ],
  components: { CTable },
  data () {
    return {
      fields: [{
        prop: 'search',
        placeholder: '搜索姓名',
        clearable: true
      }],
      columns: [
        { prop: 'id', label: 'ID', width: 100 },
        { prop: 'name', label: '姓名' },
        { slot: 'number' }
      ]
    }
  },
  methods: {
    goToDetail (row) {
      this.$router.push(`/filebackup/${row.id}`)
    }
  }
}
</script>

<style lang="scss">
</style>
